import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import refund_process_image from "../assets/images/refund_process_image.png";

const TrackRefund = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="text-[18px] ml-4 mt-8">Refund Request Details</div>

      <div className="ml-4 bg-[#F4F9FF] w-[25%] card--one rounded-lg p-4 mt-4">
        <p className="text-[16px] font-bold">
          Refund ID-<span className="italic font-normal">13E4347RY</span>
        </p>
        <p className="text-[16px] mt-2 font-bold">
          Reason-{" "}
          <span className="italic font-normal">Selected wrong plan</span>
        </p>
      </div>

      <div className="ml-8 mt-9 font-bold text-[18px]">Refund Process</div>

      <div className="ml-8 my-4">
        <div className="flex">
          <img
            src={refund_process_image}
            alt="process"
            className="w-7 object-contain"
          />
          <div>
            <div className="ml-2">
              <p className="text-[16px]">Refund Requested</p>
              <p className="text-[#828282] text-[14px]">
                Fri, 10th Sept 24, 10.04 AM
              </p>
            </div>
            <div className="ml-2 mt-14">
              <p className="text-[16px]">Refund Under Review</p>
              <p className="text-[#828282] text-[14px]">
                Fri, 12th Sept 24, 12.06 PM
              </p>
            </div>
            <div className="ml-2 mt-14">
              <p className="text-[16px]">Refund Approved</p>
              <p className="text-[#828282] text-[14px]">
                Fri, 13th Sept 24, 09.06 AM
              </p>
            </div>
            <div className="ml-2 mt-16">
              <p className="text-[16px]">Refund Initiated</p>
              <p className="text-[#828282] text-[14px]">
                Fri, 13th Sept 24, 09.06 AM
              </p>
              <p className="text-[12px]">
                Refund will be sent via original payment method.
              </p>
            </div>
            <div className="ml-2 mt-14">
              <p className="text-[16px]">Refund Sent</p>
              <p className="text-[#828282] text-[14px]">
                Fri, 13th Sept 24, 09.06 AM
              </p>
              <p className="text-[12px]">
                Refund was sent original payment method.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackRefund;
